<template>
  <div class="card" @click="$router.push({path: `/characters/${item._id}/sheet`})">
    <div class="text-center fade-out">
      <img v-if="item.image && item.image.url" class="card-img-top img-fluid" :src="item.image.url">
    </div>
    <div class="card-body">
      <h4 class="card-title clipper" :class="{ dead: isDead }">
        <span v-if="isDead">💀</span>
        {{ item.name }}
        <span v-if="isDead" class="subheader">- R.I.P.</span>
      </h4>
      <h6 class="c6 clipper">{{ item.descriptor }}</h6>
      <footer class="card-text" v-if="isAdmin">
        <small class="text-muted">{{item.player}}</small>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "character-card",
  props: ["item", "isAdmin"],
  data() {
    return {
      showViewModal: false,
      showEditModal: false
    };
  },
  computed: {
    isDead() {
      return this.$rulesets[this.item.ruleset].isDead(this.item);
    }
  }
};
</script>
